import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectConnectedToLightroomQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectConnectedToLightroomQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, lightroomConnection?: { __typename?: 'LightroomConnection', automaticallySend?: boolean | null, user?: { __typename?: 'AuthenticatedUser', id: string, email: string, name?: string | null, profileImageUrl?: string | null } | null } | null } | null } | null };


export const ProjectConnectedToLightroom = /*#__PURE__*/ gql`
    query ProjectConnectedToLightroom($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      lightroomConnection {
        automaticallySend
        user {
          id
          email
          name
          profileImageUrl
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<ProjectConnectedToLightroomQuery, ProjectConnectedToLightroomQueryVariables>;

          

          export const useProjectConnectedToLightroomQuery = (options?:QueryHookOptions<ProjectConnectedToLightroomQuery, ProjectConnectedToLightroomQueryVariables>) => useQuery(ProjectConnectedToLightroom, options);

          

          export type ProjectConnectedToLightroomQueryOptions = QueryHookOptions<ProjectConnectedToLightroomQuery, ProjectConnectedToLightroomQueryVariables>;

          

          export const useProjectConnectedToLightroomLazyQuery = (options?:LazyQueryHookOptions<ProjectConnectedToLightroomQuery, ProjectConnectedToLightroomQueryVariables>) => useLazyQuery(ProjectConnectedToLightroom, options);

          

          export type ProjectConnectedToLightroomQueryResult = ReturnType<typeof useProjectConnectedToLightroomQuery>;

          
